import { render, staticRenderFns } from "./EditProfileButton.vue?vue&type=template&id=3e282773&"
import script from "./EditProfileButton.vue?vue&type=script&lang=js&"
export * from "./EditProfileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports